<template>
	<div style="position: relative;">
		<section v-if="moduleLoaded">
			<b-overlay :show="loading" no-wrap></b-overlay>
			<b-card>
				<b-row>
					<b-form-group class="col-md-6" label="Punto de venta *" >
						<multiselect
								v-model="filters.pointOfSalesSelected"
								:options="$root.auxVars.pointOfSalesOpts"
								label="text"
								placeholder="Seleccione"
								:multiple="false"
								taggable
								track-by="value"
						>
							<template slot="option" slot-scope="props">
								<span>{{ props.option.text}}</span><br>
								<small>{{props.option.domain}}</small>
							</template>
						</multiselect>
					</b-form-group>
				</b-row>
				<b-row>
					<b-col cols="3">
						Fecha Creacion Desde
						<b-form-datepicker
							reset-button
							today-button
							size="sm"
							v-model="filters.startDate"
						/>
					</b-col>
					<b-col cols="3">
						Hasta
						<b-form-datepicker
							reset-button
							today-button
							size="sm"
							v-model="filters.endDate"
						/>
					</b-col>
					<b-col cols="3">
						Fecha servicio Desde
						<b-form-datepicker
							reset-button
							today-button
							size="sm"
							v-model="filters.serviceStartDate"
						/>
					</b-col>
					<b-col cols="3">
						Hasta
						<b-form-datepicker
							reset-button
							today-button
							size="sm"
							v-model="filters.serviceEndDate"
						/>
					</b-col>
					<b-col cols="3">
						<b-form-group
							label="Conf. cotizaciones:"
							size="sm"
							>
							<b-form-select v-model="filters.confQuote" class="mb-3" size="sm">
								<b-form-select-option :value="null">Todos</b-form-select-option>
								<b-form-select-option value="withoutPrices">Solo SIN resultados</b-form-select-option>
								<b-form-select-option value="withPrices">Solo CON resultados</b-form-select-option>
							</b-form-select>
						</b-form-group>
					</b-col>
					<b-col>
						<b-form-checkbox size="sm" v-model="onlyAirports" switches>Solo Aeropuertos</b-form-checkbox>
					</b-col>
					<b-col>
						<b-form-group
							label="."
							size="sm"
							>
							<b-button variant="outline-primary" type="button" @click="searchAction()"><md-icon icon="search"/></b-button>
						</b-form-group>

					</b-col>

				</b-row>
				<b-row>
					<b-col  class="d-flex mt-2" cols="3">
						<b-form-checkbox switch size="md" v-model="withCluster">Agrupar</b-form-checkbox>
					</b-col>
				</b-row>
				<b-row class="mt-3 mb-3">
					<b-col class="d-flex">
						<div class="mr-4">
							<h6>Mostrando :
								<input v-model="pag.perPage" style="width:80px;" :disabled="!pag.perPageEdit" @dblclick="pag.perPageEdit= !pag.perPageEdit" />
							</h6>
						</div>
						<section class="mr-3">
							<b-button-group size="md">
								<b-button @click="paginationClick('back')" variant="outline-primary">&lsaquo;</b-button>
								<b-button variant="outline-primary">{{pag.currentPage}}</b-button>
								<b-button @click="paginationClick('forward')" variant="outline-primary">&rsaquo;</b-button>
							</b-button-group>
						</section>
						<a href="#" @click="getTotalRows">Obtener el total de cotizaciones:  <b> {{totalRows}}</b> </a>
					</b-col>

				</b-row>
				<div id="zones-map" ref="map" ></div>
			</b-card>
			<b-modal ref="modal-detail-quote" title="Detail Quote" size="xl">
				<div class="modal-body-wrapper" v-if="!$root.isEmpty(quoteSelectedData)">
					<div>
						¿Como cotizó?
						<div class="container" style="max-height: 35vh;background-color: #fff; border-left: 6px solid #04AA6D; overflow-y: scroll;box-shadow: 0 2px 4px 0 rgba(0,0,0,0.16),0 2px 10px 0 rgba(0,0,0,0.12)">
							<!----<pre>{{ quoteSelectedData.body }}</pre> --->
							<b-table :items="[JSON.parse(quoteSelectedData.body)]" >
								<template v-slot:cell(metadata)="">
									<span>--</span>
								</template>
							</b-table>
						</div>
					</div>
					<div>
						Resultados
						<div class="container" style="max-height: 35vh;background-color: #fff; border-left: 6px solid #04AA6D; overflow-y: scroll;box-shadow: 0 2px 4px 0 rgba(0,0,0,0.16),0 2px 10px 0 rgba(0,0,0,0.12)">
							<!----<pre>{{ quoteSelectedData.body }}</pre> --->
							<b-table  v-if="!$root.isEmpty(quoteSelectedData.results)" :items="JSON.parse(quoteSelectedData.results)" >
								<template v-slot:cell(serviceType)="row">
									<span>{{row.item.serviceType.name}}</span>
								</template>
							</b-table>
						</div>
					</div>
				</div>

			</b-modal>
		</section>
		<section v-else>
			<b-button variant="outline-success" @click="initModule" size="lg">Iniciar Mapa <md-icon icon="location_on"></md-icon></b-button>
		</section>
	</div>
</template>
<script>
import moment from 'moment'
import Multiselect from 'vue-multiselect';
export default {
	props: {
	},
	components: { Multiselect },
	data() {
		let startDate  = moment().subtract(15,"days").format("YYYY-MM-DD");
        let endDate    = moment().subtract(1,"days").format("YYYY-MM-DD");
		return {
			moduleLoaded:false,
			loading: false,
			map: null,
			singleton:null,
			arrayBounds:[],
			markers:[],
			quoteRequests:[],
			onlyAirports:false,
			filters:{
				module:"map",
				source:"apiMozio",
				serviceStartDate:null,
				serviceEndDate:null,
				startDate:startDate,
				endDate:endDate,
				confQuote:false,
				withTotal:false,
				pointOfSalesSelected:{ "id": 6, "codename": "Shuttle Central", "description": "", "domain": "book.shuttlecentral.com", "status": "active", "value": 6, "text": "Shuttle Central" }
			},
			pag:{
				currentPage:1,
				perPage:2500,
				perPageEdit:false,
			},
			totalRows:0,
			quoteSelectedRef:null,
			quoteSelectedData:[],
			withCluster:true,
			cluster:null,
		};
	},
	computed: {
		totalQuotes() {
			return this.quoteRequests.length;
		},
		filtersComputed(){
			this.loadBounds();
			let filters = this.filters;
			filters.pointOfSalesIds = this.pointOfSalesIds;
			let pag = {
				offset:(this.pag.perPage *(this.pag.currentPage-1)),
				perPage:this.pag.perPage
			};

			filters = {...filters,...{arrayBounds:this.arrayBounds},...{pagination:pag}}
			return filters;
		},
		pointOfSalesIds(){
			let type = typeof this.filters.pointOfSalesSelected;
			let val  = []
			if(this.$root.isEmpty(this.filters.pointOfSalesSelected)) return val;
			switch(type){
				case "object":
					val =  [this.filters.pointOfSalesSelected.id]
				break;
				case "array":
					val=  this.filters.pointOfSalesSelected.map(a=>a.value);
				break;
			}
			return val;

		},
	},
	methods: {
		fetch(filters){
			this.deleteAllMarkers();
			this.loading = true;
			this.$root.api.post(`/quotes-tool-analisis/quotes`,filters).then((res) => {
				this.quoteRequests = res.data.quotes;
				this.buildMarkers();
			}).catch(this.$root.handleRequestError)
			.finally(()=>{
				this.loading= false;
			})
		},
		loadBounds(){
			if(this.$root.isEmpty(this.map)) return ;
			let bounds = this.map.getBounds();
			var NECorner = bounds.getNorthEast();
			var SWCorner = bounds.getSouthWest();
			var NWCorner = new window.google.maps.LatLng(NECorner.lat(), SWCorner.lng());
			var SECorner = new window.google.maps.LatLng(SWCorner.lat(), NECorner.lng());
			this.arrayBounds = [NWCorner, NECorner, SECorner, SWCorner]
							.map(path => ({
								latitude: path.lat(),
								longitude: path.lng()
							}))
		},
		buildMarkers(){
			let places = [];
			this.quoteRequests.forEach(quote => {
				let pickupPlace   = {...quote.pickup.geo,...quote};
				let dropoffPlace  = {...quote.dropoff.geo,...quote};

				if(this.onlyAirports){
					if(quote.pickup.isAirport) places.push(pickupPlace);
					if(quote.dropoff.isAirport) places.push(dropoffPlace);
				}else{
					places.push(pickupPlace);
					places.push(dropoffPlace);
				}

			});
			this.createMarkFromPlaces(places);
		},
		loadMap(){
			try{
				if(!this.$root.isEmpty(this.map)) throw "Map already inited";
				console.log("map init")
				let map = new window.google.maps.Map(this.$refs["map"], {
					center: { lat:25.699318323353538, lng:-100.32500002064785 },
					zoom: 4,
					streetViewControl: false
				});
				this.map = map;
			}catch(err){
				console.log(err)
			}


		},
        createMarkFromPlaces(arrayPlaces){
            arrayPlaces.forEach((place)=>{
				let icon = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
				if(place.thereWerePrices){
					icon = "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
				}
                var myLatlng = new window.google.maps.LatLng(parseFloat(place.latitude), parseFloat(place.longitude));
                let _marker = new window.google.maps.Marker({
                    position: myLatlng,
					title:place.name,
					icon: {
						url:icon
					}
                })
				_marker.addListener("click", () => {
					this.quoteSelectedRef = place.ref;
					this.showDetailQuote();
				});

				this.markers.push(_marker);
			})

			if(this.withCluster){
				this.addMarkersToCluster();
			}else{//se agregan los markers al mapa
				this.markers.forEach((_marker)=>{
					_marker.setMap(this.map);
				})
			}
        },
		deleteAllMarkers(){
			this.markers.forEach(_marker => {
				_marker.setMap(null)
			});
			this.markers = [];
			if(this.cluster)this.cluster.clearMarkers();
		},
		showDetailQuote(){
			this.$root.api.get(`/quotes-tool-analisis/${this.quoteSelectedRef}`).then((res) => {
				this.quoteSelectedData = res.data;
				this.$refs["modal-detail-quote"].show()
			}).catch(this.$root.handleRequestError);

		},
		addMarkersToCluster(){
			let vars ={
				map:this.map,
				markers:this.markers
			}
			this.cluster = new window.markerClusterer.MarkerClusterer(vars);
		},
		paginationClick(type){
			let oldCurrentPage = this.pag.currentPage;
			try{
				switch(type){
					case "forward":
						this.pag.currentPage= this.pag.currentPage+1;
					break;
					case"back":
						this.pag.currentPage= this.pag.currentPage-1;
					break;
				}
				if(this.pag.currentPage<=0) throw "err";
			}catch(err){
				this.pag.currentPage = oldCurrentPage;
				return;
			}


			let filters = {...this.filtersComputed}
			this.fetch(filters)
		},
		searchAction(){
			this.pag.currentPage = 1;
			let filters = {...this.filtersComputed}
			this.fetch(filters)
		},
		getTotalRows(ev){
			ev.preventDefault();
			let filters = {...this.filtersComputed}
			filters = {...filters,...{withTotal:true}}
			this.loading = true;
			this.$root.api.post(`/quotes-tool-analisis/quotes`,filters).then((res) => {
				this.totalRows = res.data.totalRows
			}).catch(this.$root.handleRequestError)
			.finally(()=>{
				this.loading= false;
			})
		},
		initModule(){
			this.moduleLoaded = true;
			setTimeout(() => {
				this.loadMap()
			}, 0);
		}
	},
	mounted() {
        this.$emit('mounted')
		this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['pointOfSalesOpts']})
	},
	watch: {
	}
};
</script>

<style scoped>

#zones-map {
	width: 100%;
	height: 700px;
}
#zoned-rate-editor .card-body{
    color:black !important
}
</style>

